import {useState} from 'react';
import {useLocation} from 'react-router-dom';
import {Grid, Stack, Text} from '@mantine/core';
import {
    SimplePageContentWrapper,
    TabbedComponent,
    TabComponentTab,
} from '@flexinet/ui-components';

import {Invoice} from '../types';
import {InformationPropertyCard} from './InformationPropertyCard.tsx';
import {MetadataPropertyCard} from './MetadataPropertyCard.tsx';
import {IndexPage as InvoiceItemsIndexPage} from '../../invoice-items/pages/IndexPage.tsx';
import {IndexPage as PaymentEventsIndexPage} from '../../payment-events/pages/IndexPage.tsx';

const getActiveTabFromHash = (hash: string): string | null => {
    const match = hash.match(/^#tab=(.+)$/);
    return match ? decodeURIComponent(match[1]) : null;
};

export const Profile = ({record}: { record: Invoice }) => {
    const [currentRecord] = useState(record);
    const location = useLocation();
    const activeTab = getActiveTabFromHash(location.hash);

    const tabDefinitions: { title: string, component: JSX.Element }[] = [
        {
            title: 'Overview',
            component: (
                <SimplePageContentWrapper>
                    <Stack gap={'xl'}>
                        <Text size='sm' c='dimmed'>
                            Invoice details are shown in the Information panel.
                        </Text>
                    </Stack>
                </SimplePageContentWrapper>
            ),
        },
        {
            title: 'Items',
            component: (
                <SimplePageContentWrapper>
                    <InvoiceItemsIndexPage invoiceId={currentRecord.id}/>
                </SimplePageContentWrapper>
            ),
        },
        {
            title: 'Payment events',
            component: (
                <SimplePageContentWrapper>
                    <PaymentEventsIndexPage invoiceId={currentRecord.id}/>
                </SimplePageContentWrapper>
            ),
        },
    ];

    const tabs = tabDefinitions.map(tab => ({
        ...tab,
        active: activeTab ? tab.title === activeTab : undefined,
    })) as TabComponentTab[];

    return (
        <Grid>
            <Grid.Col span={{base: 12, lg: 4}}>
                <Stack gap={'xl'}>
                    <InformationPropertyCard record={currentRecord}/>
                    <MetadataPropertyCard record={currentRecord}/>
                </Stack>
            </Grid.Col>
            <Grid.Col span={{base: 12, lg: 8}}>
                <TabbedComponent key={activeTab ?? 'default'} tabs={tabs}/>
            </Grid.Col>
        </Grid>
    );
};
